import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export type RfqTabState = Partial<{
  rfqStatus: string;
}>;

@Injectable({
  providedIn: 'root'
})
export class RfqTabStateService {
  private state: RfqTabState = {};
  private state$ = new Subject<RfqTabState>();
  public stateChanged: Observable<RfqTabState>;

  constructor() {
    this.setState({ rfqStatus: 'UNKNOWN' });
    this.stateChanged = this.state$.asObservable();
  }

  private setState(state: RfqTabState) {
    this.state = { ...this.state, ...state };
    this.state$.next(this.state);
  }

  public update(state: RfqTabState) {
    this.setState(state);
    this.state$.next(this.state);
  }
}
